export default {
  title: 'Registrieren und Punkte sammeln',
  benefits: {
    earn_points: 'Sammle Punkte mit jeder Bestellung',
    get_deals: 'Erhalte exklusive Rabatte',
    redeem_points: 'Tausche Punkte gegen kostenloses Essen ein',
  },
  terms: 'Mit der Registrierung erhältst du E-Mail- und SMS-Angebote von unserem&nbsp;',
  buttons: {
    log_in: 'Anmelden',
    sign_up: 'Registrieren',
  },
  labels: {
    already_have_account: 'Bereits ein Konto?',
  },
  signup_note:
    'Mit der Registrierung erhältst du E-Mail- und SMS-Angebote von unserem <0>Restaurant</0> und <1>FoodAmigos</1>, unserem Technologiepartner. Du stimmst unseren <2>Plattform-Bedingungen</2> und <3>Datenschutzrichtlinien</3> zu.',
};
